import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CABECERA_SESION_EDICION, SesionEdicionService} from './sesion-edicion.service';

/** Toda petición a la API dice desde qué pestaña sale; la API lo usa para no dejar pisar bloqueos ajenos. */
@Injectable()
export class SesionEdicionInterceptor implements HttpInterceptor {
    constructor(private _sesion: SesionEdicionService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.startsWith(environment.apiUrl)) {
            return next.handle(req);
        }
        return next.handle(req.clone({setHeaders: {[CABECERA_SESION_EDICION]: this._sesion.id}}));
    }
}
